<template>
  <div>
    <v-container class="mt-2" fluid v-if="isUserLoggedIn">
      <v-toolbar class="mb-3" height="30px" color="#425058" dark>
        <h4>File Upload</h4>
      </v-toolbar>
      <FileUploader/>
    </v-container>

  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import FileUploader from '../components/FileUploader.vue';

export default {
  name: 'HomeView',
  created() {

  },
  computed: {
    ...mapGetters(['getIsUserLoggedIn']),
    isUserLoggedIn() {
      return this.getIsUserLoggedIn;
    },
  },
  data() {
    return {

    };
  },
  components: {
    FileUploader,
  },

};
</script>
